import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListCheck, faCamera } from '@fortawesome/free-solid-svg-icons';
import EmptyState from '../../EmptyState';
import './clientPropertyTasks.css';

// Read-only list of a property's tasks (text + photo-backed), shown under
// Apartment Setup on the property page. Editing happens on the Tasks page or in
// the property edit request.
export default function ClientPropertyTasks({ propertyId }) {
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [lightbox, setLightbox] = useState(null);

    const fetchTasks = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get(`/api/client-requests/properties/${propertyId}/tasks?scope=all`);
            setTasks(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            console.error('Error loading property tasks:', err);
            setTasks([]);
        } finally {
            setLoading(false);
        }
    }, [propertyId]);

    useEffect(() => { fetchTasks(); }, [fetchTasks]);

    return (
        <div className="cptasks">
            <h2 className="cptasks__title"><FontAwesomeIcon icon={faListCheck} /> Tasks</h2>
            {loading ? (
                <div className="app-loading">
                    <div className="app-spinner" />
                    <div className="app-spinner-text">Loading tasks…</div>
                </div>
            ) : tasks.length === 0 ? (
                <EmptyState icon={faListCheck} title="No tasks for this property yet"
                    text="Add tasks on the Tasks page — the cleaner will follow them on every visit." />
            ) : (
                <ul className="cptasks__list">
                    {tasks.map((t) => {
                        const isPhoto = t.property_attachment_id != null;
                        return (
                            <li className="cptasks__item" key={t.id}>
                                {isPhoto
                                    ? (t.photo_url
                                        ? <img className="cptasks__thumb cptasks__thumb--clickable" src={t.photo_url} alt=""
                                            title="View photo" onClick={() => setLightbox(t.photo_url)} />
                                        : <span className="cptasks__thumb cptasks__thumb--empty"><FontAwesomeIcon icon={faCamera} /></span>)
                                    : <span className="cptasks__dot" />}
                                <span className="cptasks__text">{t.instruction}</span>
                                {isPhoto
                                    ? <span className="cptasks__chip cptasks__chip--photo"><FontAwesomeIcon icon={faCamera} /> Photo each visit</span>
                                    : t.is_report_required && <span className="cptasks__chip cptasks__chip--report"><FontAwesomeIcon icon={faCamera} /> Photo report</span>}
                            </li>
                        );
                    })}
                </ul>
            )}
            {lightbox && (
                <div className="cptasks__lightbox" onClick={() => setLightbox(null)}>
                    <img src={lightbox} alt="" onClick={(e) => e.stopPropagation()} />
                </div>
            )}
        </div>
    );
}
